import React from 'react';
import _ from 'lodash';
import { UserIntegrateTable } from '../tables/UserIntegrateTable';
import { Information } from './common';

export const DirectLinkModal = ({
  visible,
  data,
  onClose,
  multilineText = true,
  buttonText = 'このユーザーに切替',
  title = '操作ユーザー切り替え',
  showBtnClose = true,
}) => {
  let switchTargetText = '操作ユーザー';
  let afterSwitchText = '操作ユーザー切り替え後、';

  const getMessage = () => {
    return (
      <div>
        <div className='choose-user-integrate__desc'>
          操作を継続するには{`${switchTargetText}`}を切り替える必要があります。
          <br />
          ブラウザの他のページ（タブ）でBuildeeを使用しているときは、
          {`${afterSwitchText}`}
          そのページ（タブ）での操作ができなくなりますのでご注意ください。
        </div>
        {data && <UserIntegrateTable data={data} />}
      </div>
    );
  };

  return (
    <Information
      rootClassName='choose-user-integrate'
      visible={visible}
      message={getMessage()}
      title={title}
      multilineText={multilineText}
      buttonText={buttonText}
      onClose={onClose}
      showBtnClose={showBtnClose}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/DirectLinkModal.jsx